<script>
  import notify from "../../../../../../Script/notify"
  import { loadImage, validateFile } from "../../../../../Publish/BulkUpload/Script/bulkUpload"
  import { autoEnhanceImage } from "../../Script/utils"
  import CropSign from "./Components/cropSign.svelte"

  export let uploadedFile

  export let showBackgroundRemover = false

  export let showCropArea = false

  export let showAutoEnhanced = false

  export let blobURL = ""

  /**
   * @typedef {Object} closeNotification
   * @property {Function} close - Closes the notification.
   */
  /**
   * @type {closeNotification}
   */
  let closeNotification = {
    close() {},
  }

  /** @type {HTMLCanvasElement} */
  let canvas
  /**
   * @type {CanvasRenderingContext2D}
   */
  let ctx

  let imageForProcessing

  // let isInvalidFile = false

  let intensity = 150

  let actualBlob

  let autoCropDetails = {}

  const checkFile = async (e) => {
    try {
      showCropArea = false
      showBackgroundRemover = false
      const MAX_FILE_SIZE = 2 * 1024 * 1024

      let files = e.target.files[0]
      if (files.size > MAX_FILE_SIZE) throw "Maximum File size exceeded"

      uploadedFile = await validateFile(files)

      actualBlob = URL.createObjectURL(uploadedFile)

      const image = await loadImage(actualBlob)

      if (image.naturalWidth < 100 || image.naturalHeight < 100) throw "Minimum resolution should be 100 * 100 px."

      const { paddedMinX, paddedMinY, width, height, threshold, finalImage } = await autoEnhanceImage(actualBlob)

      if (width < 100 && height < 100) throw "Upload Image with better resolution"
      const aspectRatio = height / width
      if (aspectRatio < 0.15 || aspectRatio > 1.5) throw "Please review image. If needed, contact support."

      blobURL = finalImage
      intensity = threshold
      autoCropDetails = { paddedMinX, paddedMinY, width, height, isModified: false }

      showAutoEnhanced = true
    } catch (error) {
      console.error(error)
      e.target.value = uploadedFile = ""
      URL.revokeObjectURL(actualBlob)
      closeNotification.close()
      const info = "PAGE: Add Signer (Signature Croparea)\nEVENT: During validation and processing of uploaded sign image"
      closeNotification = notify.danger(error, info)
    }
  }

  const applyGrayScale = () => {
    return new Promise(async (resolve, reject) => {
      try {
        // intensity = 255 - intensity

        // console.log("intensity", intensity);
        intensity = Number(intensity)

        const width = imageForProcessing.naturalWidth
        const height = imageForProcessing.naturalHeight

        canvas.width = width
        canvas.height = height
        ctx.drawImage(imageForProcessing, 0, 0, width, height)

        const imageData = ctx.getImageData(0, 0, width, height)
        const data = imageData.data

        for (let i = 0; i < data.length; i += 4) {
          const avg = Math.floor(0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2])
          // const avg = Math.floor((data[i] + data[i + 1] + data[i + 2]) / 3)

          if (intensity < avg) data[i + 3] = 0
        }

        ctx.putImageData(imageData, 0, 0)

        resolve()
      } catch (error) {
        reject(error)
      }
    })
  }

  const handleGrayScaleSliding = async (e) => {
    try {
      await applyGrayScale(e.target.value)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Add Signer (Signature Croparea)\nEVENT: While changing the gray scale value of the signature image"
      closeNotification = notify.danger(error, info)
    }
  }

  const handleEnhancedImage = async () => {
    try {
      let blobObject = await canvasToBlob()

      // Create a new File object with the Blob and provide a default filename and type
      let file = new File([blobObject], uploadedFile.name, {
        type: "image/png",
      })

      uploadedFile = file

      blobURL = URL.createObjectURL(uploadedFile)

      showBackgroundRemover = false
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Add Signer (Signature Croparea)\nEVENT: While confirming with background removed signature image"
      closeNotification = notify.danger(error, info)
    }
  }

  /**
   * Converts a canvas element to a Blob object.
   *
   * @returns {Promise<Blob>} A Promise that resolves with the generated Blob object.
   */
  const canvasToBlob = () => {
    /**
     * @typedef {Blob} Blob - Represents a binary large object (Blob) that can store binary data.
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Blob Blob}
     */

    return new Promise((resolve) => {
      /**
       * The `toBlob` method of the canvas element is used to convert it to a Blob.
       * @param {Blob} blob - The generated Blob object.
       */
      canvas.toBlob((blob) => {
        // Once the Blob is created, the Promise is resolved with the Blob object.
        resolve(blob)
      }, "image/png")
    })
  }

  const handleCropConfirmation = async (e) => {
    try {
      let blobObject = e.detail

      // Create a new File object with the Blob and provide a default filename and type
      let file = new File([blobObject], uploadedFile.name, {
        type: "image/png",
      })

      uploadedFile = file

      blobURL = URL.createObjectURL(uploadedFile)

      showCropArea = false
    } catch (error) {
      console.error(error)
      const info = "PAGE: Add Signer (Signature Croparea)\nEVENT: While confirming with manual cropped signature image"
      notify.danger(error, info)
    }
  }

  const handleImageLoading = (e) => {
    try {
      // console.log("image loaded")

      let imageHeight = e.target.naturalHeight
      let imageWidth = e.target.naturalWidth

      // console.log({ imageHeight, imageWidth })

      if (imageWidth < 100 || imageHeight < 100) {
        uploadedFile = ""
        throw "Minimum resolution should be 100 * 100 px."
      }

      // if (imageWidth < 296 || imageHeight < 164) {
      //   uploadedFile = ""
      //   throw "Minimum resolution should be 296 * 164 px."
      // }

      // if (imageWidth > 592 || imageHeight > 205) {
      //   showCropArea = isInvalidFile = true
      //   throw "Maximum resolution should be 592 * 205 px. Kindly crop the uploaded image."
      // } else {
      //   showCropArea = isInvalidFile = false
      // }
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Add Signer (Signature Croparea)\nEVENT: While validating uploaded file resolution"
      closeNotification = notify.danger(error, info)
    }
  }

  // const handleSigning = () => {
  //   try {
  //     if (!uploadedFile) throw "Kindly upload image to continue"
  //     if (showBackgroundRemover) throw "Kindly continue to remove background or else go back and sign."
  //     if (showCropArea) throw "Kindly continue to crop signature or else go back and sign."

  //     dispatch("sign", uploadedFile)
  //   } catch (error) {
  //     console.error(error)
  //     closeNotification.close()
  //     closeNotification = notify.danger(error)
  //   }
  // }

  const handleRemoveBgInit = async () => {
    try {
      imageForProcessing = await loadImage(blobURL)
      showBackgroundRemover = true
      setTimeout(async () => {
        ctx = canvas.getContext("2d", { willReadFrequently: true })
        await applyGrayScale()
      }, 10)
    } catch (error) {
      console.error(error)
      closeNotification.close()
      const info = "PAGE: Add Signer (Signature Croparea)\nEVENT: While intiating background removal of the signature image"
      closeNotification = notify.danger(error, info)
    }
  }
</script>

{#if !uploadedFile}
  <div class="relative flex h-full w-full select-none flex-col items-center justify-center gap-3 rounded-md border border-dashed border-[#a0a1a580] py-3 text-xs font-normal text-gray-100 hover:bg-[#f7f7f7] hover:dark:bg-bodyblack md:py-6">
    <input on:change={checkFile} type="file" accept=".png,.jpeg,.jpg" class="absolute inset-0 cursor-pointer opacity-0" />
    <div class="mb-3 text-3xl text-blue-500 md:text-6xl">
      <i class="fa-solid fa-cloud-arrow-up" />
    </div>
    <span>Click here to upload your file or drag</span>
    <p>
      Supported formats:
      <span class="text-blue-500">PNG, JPEG, JPG (max 2 MB).</span>
    </p>
    <p>
      Minimum Dimensions: <span class="text-blue-500">100 × 100 px</span>
      .
    </p>
  </div>
{:else}
  <div class="relative flex h-full w-full items-center rounded-md bg-[#f7f7f7] p-3 dark:bg-[#292a2f]">
    <div class="flex h-full w-full flex-col items-center gap-3">
      {#if showAutoEnhanced}
        <div class="group relative max-h-[40vh] max-w-[75%]">
          <img src={blobURL} alt="previewESign" class="max-h-[40vh] max-w-full" style="background:url('assets/img/grid.png')" />

          <div class="absolute inset-0 hidden items-center justify-center gap-6 text-2xl group-hover:flex group-hover:bg-[#000000cc]">
            <button
              on:click={() => {
                uploadedFile = ""
              }}
              data-tooltip="Clear File"
              tooltip-position="top"
              type="button"
              class="text-red-500"
            >
              <i class="fa-solid fa-circle-xmark" />
            </button>
            <button
              on:click={() => {
                blobURL = actualBlob
                showAutoEnhanced = false
              }}
              data-tooltip="Edit Manually"
              tooltip-position="top"
              type="button"
              class="text-blue-500"
            >
              <i class="fa-solid fa-pen-to-square" />
            </button>
          </div>
        </div>
      {:else}
        <!-- Manual Edit -->
        {#if showBackgroundRemover}
          <canvas bind:this={canvas} class="aspect-auto h-[40vh] max-w-[75%] rounded-md border border-gray-400" style="background:url('assets/img/grid.png')" />
          <div class="mt-3 w-full cursor-pointer md:w-1/2">
            <input bind:value={intensity} on:input={handleGrayScaleSliding} type="range" min="70" max="230" class="cursor-pointer" />
          </div>

          <div class="mt-3 flex w-full justify-center gap-3">
            <button
              on:click={() => {
                showBackgroundRemover = false
              }}
              type="button"
              class="w-fit rounded-md bg-blue-500 py-2 px-4 text-sm font-bold text-white"
            >
              <span>
                <i class="fa-solid fa-reply" />
              </span>
              &nbsp;&nbsp;Back
            </button>
            <button on:click={handleEnhancedImage} type="button" class="w-fit rounded-md bg-violet-500 py-2 px-4 text-sm font-bold text-white">
              <span>
                <i class="fa-solid fa-eraser" />
              </span>
              &nbsp;&nbsp;Remove Background
            </button>
          </div>
        {:else if showCropArea}
          <CropSign
            {blobURL}
            {autoCropDetails}
            on:click={() => {
              // if (isInvalidFile) uploadedFile = blobURL = ""

              showCropArea = false
            }}
            on:confirm={handleCropConfirmation}
          />
        {:else}
          <div class="aspect-auto max-w-[75%]">
            <img src={blobURL} alt="previewESign" class="max-h-[40vh]" style="background:url('assets/img/grid.png')" />
          </div>

          <!-- <img style="background:url('assets/img/grid.png')" src={blobURL} alt="previewESign" class="aspect-auto max-h-[40vh] max-w-[75%]" /> -->
          <div class="flex w-full flex-wrap justify-center gap-3">
            <button
              on:click={() => {
                uploadedFile = ""
              }}
              type="button"
              class="w-fit rounded-md bg-red-500 py-2 px-4 text-sm font-bold text-white"
            >
              <span>
                <i class="fa-solid fa-circle-xmark" />
              </span>
              &nbsp;&nbsp;Clear File
            </button>
            <button
              on:click={() => {
                showCropArea = true
                showBackgroundRemover = false
              }}
              type="button"
              class="w-fit rounded-md bg-violet-500 py-2 px-4 text-sm font-bold text-white"
            >
              <span>
                <i class="fa-solid fa-crop" />
              </span>
              &nbsp;&nbsp;Crop Image
            </button>
            <button on:click={handleRemoveBgInit} type="button" class="w-fit rounded-md bg-blue-500 py-2 px-4 text-sm font-bold text-white">
              <span>
                <i class="fa-solid fa-eraser" />
              </span>
              &nbsp;&nbsp;Remove Background
            </button>
          </div>
        {/if}
      {/if}
    </div>
  </div>
{/if}

<!-- <div class="flex flex-row items-center justify-center gap-3 rounded-md bg-bodyblack p-2 sm:flex md:gap-0 md:p-4">
  <button on:click type="button" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-lightgray px-3 py-1.5 text-sm font-medium text-white hover:bg-red-500 hover:text-white focus:outline-none sm:ml-3 sm:w-auto">
    <span>
      <i class="fa-solid fa-circle-xmark" />
    </span>
    <span class="select-none">&nbsp;&nbsp;Cancel&nbsp;&nbsp;</span>
  </button>
  <button on:click={handleSigning} type="submit" class="flex h-9 min-h-full min-w-[36px] items-center justify-center rounded-md border border-[#a0a1a580] bg-lightgray px-3 py-1.5 text-sm font-medium text-white hover:bg-green-500 hover:text-white focus:outline-none sm:ml-3 sm:w-auto">
    <span>
      <i class="fa-solid fa-circle-check" />
    </span>
    <span class="select-none">&nbsp;&nbsp;Confirm&nbsp;&nbsp;</span>
  </button>
</div> -->
